import { render } from "./HeroiconsSolidShoppingBag.vue?vue&type=template&id=bc40903e"
const script = {}

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidShoppingBag.vue"]])

export default __exports__